import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import AssetBrowser from './AssetBrowser';
import AddToBody from '../helpers/AddToBody';
import store from '../../store/Store';

class ModalAssetBrowser extends Component {
    static propTypes = {
        onSelect: PropTypes.func,
        onClose: PropTypes.func,
        onOpen: PropTypes.func,
        showButton: PropTypes.bool,
        filter: PropTypes.string,
        category: PropTypes.string,
        open: PropTypes.bool,
        afterSearchBar: PropTypes.element,
        edit: PropTypes.bool,
        remove: PropTypes.bool,
        isDisabled: PropTypes.bool,
        hasAccess: PropTypes.object
    };
    static defaultProps = {
        showButton: true,
        onClose: () => {},
        onOpen: () => {},
        filter: '.*',
        store: store,
        category: '',
        open: false,
        edit: false,
        remove: false,
        isDisabled: false
    };

    constructor(props) {
        super(props);
        this.state = {
            open: false
        };
        this.onClose = this.onClose.bind(this);
        this.onOpen = this.onOpen.bind(this);
        this.onSelect = this.onSelect.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== undefined) {
            this.setState({
                open: nextProps.open
            });
        }
    }

    componentDidMount() {
        this.setState({
            open: this.props.open
        });
    }

    onClose() {
        this.props.onClose(false);
        this.setState({
            open: false
        });
    }

    onOpen() {
        if (!this.props.isDisabled) {
            this.props.onOpen(true);
            this.setState({
                open: true
            });
        }
    }

    onSelect(assets) {
        if (this.props.onSelect && typeof this.props.onSelect === 'function') {
            this.props.onSelect(assets);
        }
        assets.forEach(asset => (asset.selected = false));
        this.onClose();
    }
    onSearch(text) {
        this.assetBrowser && this.assetBrowser.getWrappedInstance().onSearch(text);
    }
    render() {
        return (
            <div>
                {this.props.showButton && (
                    <button
                        className={`spark-btn spark-btn--sm align-middle ${this.props.isDisabled ? 'disabled' : ''}`}
                        type="button"
                        onClick={() => {
                            this.onOpen();
                        }}
                    >
                        <i className="spark-icon spark-icon-pictures spark-icon--lg"></i>
                    </button>
                )}
                {this.state.open && (
                    <AddToBody>
                        {/* <Portal isOpened> */}
                        <div
                            ref={node => {
                                this.node = node;
                            }}
                            className={`asset-browser--modal spark-modal ${this.state.open ? 'active' : ''}`}
                            onClick={event => {
                                event.stopPropagation();
                                if (
                                    event.target.className === 'spark-modal__scroll' ||
                                    event.target.className === 'spark-modal'
                                ) {
                                    this.onClose();
                                }
                            }}
                        >
                            <div className="spark-modal__scroll">
                                <div className="spark-modal__content col-xs-10">
                                    <div className="spark-modal__body">
                                        <a
                                            onClick={this.onClose}
                                            className="spark-modal__close spark-icon-close"
                                            title="Close Modal"
                                        />
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <AssetBrowser
                                                    filter={this.props.filter}
                                                    category={this.props.category}
                                                    hasAccessForDelete={_.get(this.props, 'hasAccess.delete', true)}
                                                    selectMultiple={false}
                                                    onSelect={this.onSelect}
                                                    edit={this.props.edit}
                                                    remove={this.props.remove}
                                                    displayMode="grid"
                                                    store={this.props.store}
                                                    afterSearchBar={this.props.afterSearchBar}
                                                    ref={node => (this.assetBrowser = node)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </Portal> */}
                    </AddToBody>
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        chainId: state.app.selected.chain.Id,
        hotelId: state.app.selected.selectedHotel.id,
        level: state.app.selected.level
    };
};
const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(ModalAssetBrowser);



// WEBPACK FOOTER //
// ./src/components/widgets/ModalAssetBrowser.js